import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { map } from 'lodash';

import ActiveFilter from './ActiveFilter';
import { FilterBaseType } from '../filter-types';

import './styles/ActiveFilters.css';

const formatSeperator = (hasBoolean, booleanSeparator) => {
  if (!hasBoolean) {
    return ', ';
  }
  return booleanSeparator === 'OR' || booleanSeparator === true
    ? ' OR '
    : ' AND ';
};

const ActiveFilters = ({
  filters,
  onClear,
  onClearAll,
  hasBool,
  actionButtonFunc,
  actionButtonText,
  showActionButton
}) => (
  <>
    {}
    <div className="tvt-filters__active-filters">
      <ul className="tvt-filters__active-filters-list">
        {map(
          filters,
          ({ id, value, label, hasBoolean, booleanSeparator, tooltip }) =>
            id !== 'segments' && (
              <ActiveFilter
                key={id}
                id={id}
                label={label}
                tooltip={tooltip}
                onClear={() => onClear(id)}
                value={value}
                booleanSeparator={formatSeperator(
                  hasBool && hasBoolean,
                  booleanSeparator
                )}
              />
            )
        )}
        {showActionButton ? (
          <Button
            bsStyle="link"
            bsSize="small"
            className="tvt-filters__active-filters-clear"
            onClick={actionButtonFunc}
          >
            {actionButtonText}
          </Button>
        ) : null}
        <Button
          bsStyle="link"
          bsSize="small"
          className="tvt-filters__active-filters-clear"
          onClick={onClearAll}
        >
          Clear All
        </Button>
      </ul>
    </div>
  </>
);

ActiveFilters.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape(FilterBaseType)).isRequired,
  onClear: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  hasBool: PropTypes.bool,
  actionButtonFunc: PropTypes.func,
  actionButtonText: PropTypes.string,
  showActionButton: PropTypes.bool
};

ActiveFilters.defaultProps = {
  hasBool: false,
  actionButtonFunc: () => {},
  actionButtonText: '',
  showActionButton: false
};

export default ActiveFilters;
